"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmallHoverTooltip = exports.DetailedTooltip = void 0;
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Utils_1 = require("../../Utils");
var ViewerAvatar_1 = require("../../Components/ViewerAvatar");
var styles = __importStar(require("./ActivityChartTooltip.css"));
var DetailedTooltip = function (_a) {
    var _b = _a.payload, luxonDateTime = _b.luxonDateTime, viewCount = _b.viewCount, views = _b.views, timeUnit = _a.timeUnit, onSessionClick = _a.onSessionClick, onClose = _a.onClose;
    if (views.length === 0) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var totalViewDuration = views.reduce(function (sum, current) { return sum + current.session.duration; }, 0);
    var averageViewDuration = totalViewDuration / views.length;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.detailedTooltipContent, gap: "m" },
        react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.closeButton, icon: react_1.default.createElement(icons_1.Close, null), size: kaleidoscope_1.ButtonSize.Small, onClick: onClose }),
        renderDateTimeComponent(luxonDateTime, timeUnit),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.summaryStats, gap: "xs" },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs", align: "center" },
                react_1.default.createElement(icons_1.Clock, { color: "default" }),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true },
                    (0, Utils_1.formatViewDuration)(averageViewDuration),
                    " avg. time spent")),
            react_1.default.createElement("div", { className: styles.divider }),
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs", align: "center" },
                react_1.default.createElement(icons_1.Preview, { color: "default" }),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true },
                    viewCount,
                    " views"))),
        react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.viewersList, gap: "xs" }, views.map(function (_a) {
            var viewer = _a.viewer, session = _a.session;
            return (react_1.default.createElement(kaleidoscope_1.Stack, { key: session.pageViewId, direction: "horizontal", align: "center", justify: "spaceBetween", gap: "xs" },
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.avatarAndName, direction: "horizontal", align: "center", gap: "xs" },
                    react_1.default.createElement(ViewerAvatar_1.ViewerAvatar, { viewer: viewer, size: kaleidoscope_1.AvatarSize.Small }),
                    react_1.default.createElement(kaleidoscope_1.Text, { className: styles.viewerName, size: "xs", strong: true }, viewer.displayName)),
                react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.durationAndArrow, direction: "horizontal", align: "center", justify: "end", gap: "xxs" },
                    react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, (0, Utils_1.formatViewDuration)(session.duration)),
                    react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.ArrowRight, null), size: kaleidoscope_1.ButtonSize.Small, onClick: function () { return onSessionClick(viewer, session.pageViewId); } }))));
        }))));
};
exports.DetailedTooltip = DetailedTooltip;
var SmallHoverTooltip = function (_a) {
    var _b = _a.payload, luxonDateTime = _b.luxonDateTime, viewCount = _b.viewCount, timeUnit = _a.timeUnit, openDetailedTooltip = _a.openDetailedTooltip;
    var hasViews = viewCount > 0;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.hoverTooltipContent, gap: "xs" },
        renderDateTimeComponent(luxonDateTime, timeUnit),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs", justify: "center" },
            react_1.default.createElement(icons_1.Preview, { color: "default" }),
            react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true }, hasViews ? "".concat(viewCount, " views") : "No views")),
        hasViews && (react_1.default.createElement(kaleidoscope_1.Button, { onClick: openDetailedTooltip, type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small }, "Show details"))));
};
exports.SmallHoverTooltip = SmallHoverTooltip;
function renderDateTimeComponent(luxonDateTime, timeUnit) {
    return (react_1.default.createElement(kaleidoscope_1.Text, { strong: true, secondary: true, size: "s", align: "center" }, luxonDateTime.toLocaleString({
        day: timeUnit === "day" ? "numeric" : undefined,
        month: "short",
        year: "numeric",
    })));
}
